export const TOOLTIP_ADD     = 'TOOLTIP_ADD';
export const TOOLTIP_HIDE    = 'TOOLTIP_HIDE';
export const TOOLTIP_REMOVE  = 'TOOLTIP_REMOVE';
export const TOOLTIP_SHOW    = 'TOOLTIP_SHOW';
export const TOOLTIP_EDIT    = 'TOOLTIP_EDIT';



// WEBPACK FOOTER //
// ./app/constants/tooltipTypes.js